import React from "react";
import {Trans} from "@lingui/react/macro";
import MobPressable from "./MobPressable";
import {DynamicIcon} from "lucide-react/dynamic";
import {MOBCOLORS} from "../../configs/AppConfig";


export function MobEditButton({onClick,text,bordered})
{

    return(
        <MobPressable style={{
            display: "flex",
            alignItems: "center",
            justifyContent:"center",
            gap:5,
            backgroundColor: MOBCOLORS.blue.backgroundColor,
            color:MOBCOLORS.blue.color,
            //border:bordered?"2px solid #2B70A9":"none",
            padding: "5px 15px",
            borderRadius: 25,
            fontSize:15,
            cursor:"pointer",
            boxShadow:"0 2px 4px rgba(0, 0, 0, 0.08)",
        }}
             onClick={onClick}
        >
            <DynamicIcon name={"pen"} color={MOBCOLORS.blue.color} size={15} style={{display:"flex",justifyContent:"center",alignItems:"center"}} />

            <span>
                {text || (
                    <Trans>Modifier</Trans>
                )}
            </span>
        </MobPressable>
    )
}
